import { Block, Blocks, cloneBlock } from '@chameleoncreator/creator-app';
import { createBlock } from './block';
import { createHeader } from './header';
import { createTopic } from './topic';
import { createScorm } from './scorm';

export const createModule = (title: string): Block => {
  return createBlock(
    'Module',
    [
      createScorm(),
      createHeader(),
      createBlock('AnimationGroup', [createTopic('Topic #1')], {
        meta: { subType: 'Topic' },
      }),
    ],
    {
      props: {
        passMark: 80,
        name: title,
        theme: {
          userPalette: [],
        },
      },
    }
  );
};

export const addScormBlock = (mod: Block) => (scormBlock: Block): Block => {
  if (mod.type !== 'Module') {
    return mod;
  }

  const nextMod = cloneBlock(mod);
  (nextMod.children as Block[]).unshift(scormBlock)

  return nextMod
}

// Returns a new block that should be saved. this will be the TopicGroup block
// contained within the module
export const addTopic = (blocks: Blocks) => (mod: Block) => (
  topic: Block,
  position: number
): Block => {
  if (mod.type !== 'Module') {
    return mod;
  }

  const group = (mod.children as Block[]).find(child => {
    const block = blocks[child.id];
    return block.meta && block.meta.subType === 'Topic';
  });

  if (!group) {
    throw new Error("Topic group missing from topic. That shouldn't happen");
  }

  const nextGroup = cloneBlock(blocks[group.id]);
  (nextGroup.children as Block[]).splice(position, 0, topic);

  return nextGroup;
};

export const addTopicToGroup = (blocks: Blocks) => (
  group: Block,
  topic: Block,
  position: number
): Block => {
  // console.log(group);
  if (!group.meta || group.meta.subType !== 'Topic') {
    throw new Error('Group must contain Topics');
  }

  const nextGroup = cloneBlock(blocks[group.id]);
  (nextGroup.children as Block[]).splice(position, 0, topic);
  return nextGroup;
};

export const removeTopic = (blocks: Blocks) => (
  mod: Block,
  id: string
): Block => {
  if (mod.type !== 'Module') {
    return mod;
  }

  let group = (mod.children as Block[]).find(child => {
    const block = blocks[child.id];
    return block.meta && block.meta.subType === 'Topic';
  });

  if (!group) {
    throw new Error("Topic group missing from topic. That shouldn't happen");
  }

  group = blocks[group.id];

  return removeTopicFromGroup(blocks)(group, id);
};

export const removeTopicFromGroup = (blocks: Blocks) => (
  group: Block,
  id: string
): Block => {
  if (!group) {
    throw new Error("Topic group missing from module. That shouldn't happen");
  }

  if (!group.meta || group.meta.subType !== 'Topic') {
    throw new Error('Group must contain Topics');
  }

  const nextGroup = cloneBlock(blocks[group.id]);

  const index = (nextGroup.children as Block[]).findIndex(r => r.id === id);

  (nextGroup.children as Block[]).splice(index, 1);
  return nextGroup;
};
